var _ellipse, _defs, _circle, _path, _defs2, _rect, _ellipse2, _circle2, _circle3, _ellipse3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPadel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64,
    cy: 110,
    rx: 28,
    ry: 8,
    fill: "rgba(0,0,0,0.2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "redGradient",
    cx: 0.4,
    cy: 0.4,
    r: 0.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#e53935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#b71c1c"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 48,
    r: 36,
    fill: "url(#redGradient)",
    stroke: "#880e4f",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32,48 a32,32 0 0,1 64,0",
    fill: "none",
    stroke: "#f8bbd0",
    strokeWidth: 2,
    strokeDasharray: "4,3"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "woodGradient",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#a1887f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#5d4037"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 76,
    width: 12,
    height: 36,
    rx: 3,
    fill: "url(#woodGradient)",
    stroke: "#3e2723",
    strokeWidth: 1
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64,
    cy: 76,
    rx: 8,
    ry: 4,
    fill: "#4e342e"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 30,
    r: 10,
    fill: "#fff",
    stroke: "#ccc",
    strokeWidth: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 28,
    r: 2,
    fill: "#eee"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 98,
    cy: 40,
    rx: 6,
    ry: 2,
    fill: "rgba(0,0,0,0.1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadel);
export default __webpack_public_path__ + "static/media/padel.ab82b6fc281e8198d50de3d890497240.svg";
export { ForwardRef as ReactComponent };